var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-message--text deleted",
      class: {},
      style: Object.assign(
        {},
        _vm.messageColors,
        //backgroundColor: determineColor(message),
        _vm.extendedStyle || {}
      ),
    },
    [
      [
        _c(
          "div",
          {
            staticClass: "sc-message--toolbox",
            style: { background: _vm.messageColors.backgroundColor },
          },
          [
            _vm.me && _vm.message.id != null && _vm.message.id != undefined
              ? _c(
                  "button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove")
                      },
                    },
                  },
                  [
                    _c(
                      "icon-base",
                      {
                        attrs: {
                          color: _vm.messageColors.color,
                          "icon-name": "remove",
                          width: "10",
                        },
                      },
                      [_c("icon-cross")],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("text-message-toolbox", null, {
              me: _vm.me,
              message: _vm.message,
            }),
          ],
          2
        ),
      ],
      _vm._v(" "),
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              {
                class: { "translatable-content-wrapper": _vm.isTranslatable() },
              },
              [
                _c(
                  "div",
                  {
                    class: { "after-translate-top": _vm.isTranslatable() },
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "sc-message--text-content m-1 ml-3 mr-3",
                        staticStyle: { "word-break": "break-word" },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("info"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.messageText) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "after-translate-bottom":
                        !!_vm.translate && _vm.isTranslateOpen && !_vm.me,
                    },
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "end",
                      "align-items": "center",
                      padding: "0 0.3rem",
                    },
                  },
                  [
                    _vm.message.data.meta
                      ? _c(
                          "span",
                          {
                            staticClass: "sc-message-meta-new",
                            style: { color: _vm.messageColors.color },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.metaShorter(_vm.message.data.meta))
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.message.data.meta2
                      ? _c(
                          "span",
                          {
                            staticClass: "sc-message--meta2",
                            style: { color: _vm.messageColors.color },
                          },
                          [_vm._v(_vm._s(_vm.message.data.meta2))]
                        )
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        },
        {
          me: _vm.me,
          message: _vm.message,
          messageColors: _vm.messageColors,
          messageText: _vm.messageText,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }